import { InputAdornment, Box, Button, FormControl, MenuItem, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Stack, Pagination } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ModalRecordKeeping from "../../components/ModalController/ModalRecordKeeping";
import LoaderAnimation from '../../components/LoaderAnimation'
import * as api from '../../services/ApiConsultDoctor'
import * as apiRefer from '../../services/refer/ApiPublicRefer'
import moment from "moment";
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import dayjs from 'dayjs';
import IconButton from '@mui/material/IconButton';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import ModalCalendar from '../../components/ModalController/ModalCalendar'
import { notifyError, notifyInfo, notifySuccess } from "../../components/NotifyToast";

export const history = {
    backgroundColor: '#E3E9F2',
    borderRadius: 1,
    '&:hover': {
        backgroundColor: '#eee4f7',
    },
}

export const buttom_primary = {
    backgroundColor: '#082C91',
    border: '1px solid #082C91',
    padding: '0.5rem 1rem',
    width: '150px',
    borderRadius: 1,
    color: '#fff',
    boxShadow: 'none',
    '&:hover': {
        backgroundColor: '#082C91',
        boxShadow: 'none',
    }
}

export const buttom_secondary = {
    backgroundColor: '#E3E9F2',
    border: '1px solid #E3E9F2',
    padding: '0.5rem 1rem',
    width: '150px',
    borderRadius: 1,
    color: '#082C91',
    boxShadow: 'none',
    '&:hover': {
        backgroundColor: '#eee4f7',
        boxShadow: 'none',
    }
}

export default function AppointmentPatients({ value }) {

    return (
        <>
            <Box sx={{
                textAlign: 'start',
                ml:'2rem',
                color: '#082C91',
                fontSize: '24px',
                '@media (max-width: 512px)': { textAlign: 'center', }
            }}>
                {value === 0 ? "ผู้ป่วยนัดจากระบบ" : "รายการที่รับคำปรึกษา"}
            </Box>

            {value === 0 && <SystemPatients />}
            {value === 1 && <HospitalPatients />}
        </>
    )
}

const SystemPatients = () => {

    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)

    const [hospital, setHospital] = useState('')
    const [optionHospital, setOptionHospital] = useState([])
    const [department, setDepartment] = useState('')
    const [optionDepartment, setOptionDepartment] = useState([])
    const [namePatient, setNamePatient] = useState('')
    const [pid, setPid] = useState('')
    const [date, setDate] = useState(dayjs(moment(new Date()).format('YYYY-MM-DD')))

    const [dataSystem, setDataSystem] = useState([])

    const [openModal, setOpenModal] = useState(false)
    const [docNumber, setDocNumber] = useState('')

    const [numPage, setNumPage] = useState(5)
    const [page, setPage] = useState(1)
    const [maxPage, setMaxPage] = useState(1)
    const [showList, setShowList] = useState([])

    const [disabledDay, setDisabledDay] = useState([])
    const [openCalendar, setOpenCalendar] = useState(false)

    const [dataAll, setDataAll] = useState([])
    const [dataHos, setDataHos] = useState([])

    const [room, setRoom] = useState('')
    const [optionRoom, setOptionRoom] = useState([])

    const [itemFindIndex, setItemFindIndex] = useState(null)

    useEffect(() => {
        getHospital()
        findDepartment()
    }, [])

    useEffect(() => {
        setShowList([])
        findDepartment()
    }, [hospital])

    useEffect(() => {
        findRoom()
    }, [department])


    useEffect(() => {
        findTelemedicine()
    }, [numPage, hospital, department])

    useEffect(() => {
        setPage(1)
    }, [numPage])

    useEffect(() => {
        let start = page * numPage - numPage
        setShowList(searchData().slice(start, start + numPage))
    }, [page, dataSystem, namePatient, pid])

    const handlePageChange = (event, page) => {
        setPage(page)
    }

    const systempatientAndpointofcare = async (pid) => {
        window.open(`/systemPatientInformation?PID=${pid}`)
        // setLoading(true)
        // let res = await apiRefer.consent(pid)
        // setLoading(false)
        // if (res) {
        //     if (res['data']['code'] === 200) {
        //         window.open(`/systemPatientInformation?PID=${pid}`)
        //     } else {
        //         notifyInfo(res['data']['message'])
        //     }
        // } else {
        //     notifyError('ไม่ตอบสนอง')
        // }
    }

    const openModalRecondKeeping = (DocNumber, ItemFindIndex) => {
        setDocNumber(DocNumber)
        setOpenModal(true)
        setItemFindIndex(ItemFindIndex)
    }

    const openTreatmentHistory = (pid, DocNumber) => {
        navigate('/treatmentHistory', {
            state: {
                PID: pid,
                DocNumber: DocNumber
            }
        })
    }

    const getHospital = async () => {
        setLoading(true)
        let res = await api.findDepartment()
        setLoading(false)
        if (res) {
            if (res['data']['code'] === 200) {
                setDataAll(res['data']['data'])
                // console.log(res['data']['data'])
                const List = []
                for (let i = 0; i < res['data']['data'].length; i++) {
                    if (res['data']['data'][i]['HospitalCode'] === localStorage.getItem('hospital_code')) {
                        List.push(res['data']['data'][i]['Clinic'])
                    }
                }
                let data_new = List.reduce((prev, cur) => prev.concat(cur), [])
                console.log(data_new)
                setDataHos(data_new)
                const unique = [...new Map(data_new.map((m) => [m.ClinicCode, m])).values()] //กรองชื่อซ้ำ
                // console.log(unique)

                setOptionHospital(unique)
            } else {
                notifyInfo(res['data']['message'])
            }
        } else {
            notifyError('ไม่ตอบสนอง')
        }
    }

    const findDepartment = async () => {
        let code = []
        for (let i = 0; i < dataHos.length; i++) {
            if (dataHos[i]['ClinicCode'] === hospital) {
                code.push(dataHos[i]['DepartmentCode'])
            }
        }
        const List = dataAll.filter(item => {
            return code?.find((menuItem) => menuItem === item['DepartmentCode'])
        })
        setOptionDepartment(List)
    }

    const findRoom = () => {
        let ListRoom = []
        for (let i = 0; i < optionDepartment.length; i++) {
            if (optionDepartment[i]['DepartmentCode'] === department) {
                ListRoom.push(optionDepartment[i]['RoomConference'])
            }
        }
        const unique = [...new Map(ListRoom[0]?.map((m) => [m.RoomConferenceName, m])).values()] //กรองชื่อซ้ำ
        setOptionRoom(unique)
        console.log(unique)
    }

    const clickConference = () => {
        // const url = optionRoom[0][room-1]
        // window.open(url['ConferenceURL'], '_system')
        let RoomLink = []
        for (let i = 0; i < optionRoom.length; i++) {
            if (optionRoom[i]['RoomConferenceName'] === room) {
                RoomLink.push(optionRoom[i]['ConferenceURL'])
            }
        }
        window.open(RoomLink, '_system')
    }

    const findTelemedicine = async () => {
        let dateNow = moment(date['$d']).format('YYYY-MM-DD')

        setLoading(true)
        let res = await api.findTelemedicine(dateNow)
        setLoading(false)
        if (res) {
            if (res['data']['code'] === 200) {
                if (hospital === ' ') {
                    setDataSystem(res['data']['data'])
                    setMaxPage((Math.ceil(res['data']['data'].length / numPage)))
                } else if (hospital !== '' && (department === '' || department === ' ')) {
                    const List = []
                    for (let i = 0; i < res['data']['data'].length; i++) {
                        if (res['data']['data'][i]['HospitalCodeTo'] === hospital) {
                            List.push(res['data']['data'][i])
                        }
                    }
                    setDataSystem(List)
                    setMaxPage((Math.ceil(List.length / numPage)))
                } else if (hospital !== '' && department !== '') {
                    const List = []
                    for (let i = 0; i < res['data']['data'].length; i++) {
                        if (res['data']['data'][i]['DepartmentCode'] === department && res['data']['data'][i]['HospitalCodeTo'] === hospital) {
                            List.push(res['data']['data'][i])
                        }
                    }
                    setDataSystem(List)
                    setMaxPage((Math.ceil(List.length / numPage)))
                } else {
                    setDataSystem(res['data']['data'])
                    setMaxPage((Math.ceil(res['data']['data'].length / numPage)))
                }

            } else {
                setDataSystem([])
            }
        } else {
            notifyError('ไม่ตอบสนอง')
        }
    }

    const cancelTelemedicine = async (DocNumber) => {
        setLoading(true)
        let res = await api.cancelTelemedicine(DocNumber)
        setLoading(false)
        if (res) {
            if (res['data']['code'] === 200) {
                notifySuccess('ลบนัดหมายสำเร็จ')
                findTelemedicine()
            } else {
                notifyInfo(res['data']['message'])
            }
        } else {
            notifyError('ไม่ตอบสนอง')
        }
    }

    const deleteAppointment = (DocNumber) => {
        cancelTelemedicine(DocNumber)
    }

    const convertDate = (dataDate) => {
        const date = new Date(dataDate)
        const optionDate = {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        }
        const thaiLocale = 'th-TH';
        const formattedDate = date.toLocaleDateString(thaiLocale, optionDate)

        const newDate = `${formattedDate}`
        return newDate
    }

    const searchData = () => {
        return dataSystem.filter((item) =>
            (namePatient === '' || item['Name'].includes(namePatient)) &&
            (pid === '' || item['PID'].includes(pid))
        )
    }

    if (openModal) {
        document.body.style.overflow = "hidden";
    } else {
        document.body.style.overflow = "auto";
    }

    return (
        <>
            <LoaderAnimation loading={loading} />
            {openCalendar &&
                <ModalCalendar
                    onClose={() => { setOpenCalendar(false) }}
                    onFinished={() => {
                        findTelemedicine()
                    }}
                    value={date ? dayjs(moment(date['$d']).format('YYYY-MM-DD')) : dayjs(moment(new Date()).format('YYYY-MM-DD'))}
                    onChange={(e) => setDate(e)}
                    disableDay={disabledDay}
                />
            }
            <Box sx={{
                fontSize: 18,
                '@media (max-width: 1023px)': {
                    fontSize: 14,
                },
                '@media (max-width: 800px)': {
                    fontSize: 12,
                }
            }}>
                <Box sx={{
                    backgroundColor: '#FFFFFF',
                    border: '1px solid #E1E3E9',
                    borderRadius: 2,
                    marginTop: 2,
                    padding: 2,
                    '@media (max-width: 1023px)': {
                        marginTop: 2,
                        padding: 1
                    },
                    '@media (max-width: 800px)': {
                        marginTop: 1,
                        padding: 1
                    }
                }}>
                    <div style={{ color: '#082C91' }} >Filters</div>
                    <Box sx={{
                        padding: '10px 40px',
                        display: 'grid',
                        gridTemplateColumns: '2fr 2fr 2fr 1fr',
                        gridGap: 30,
                        alignItems: 'flex-end',
                        '@media (max-width: 1100px)': {
                            padding: '5px 30px',
                            gridTemplateColumns: '1fr 1fr',
                            gridGap: 20
                        },
                        '@media (max-width: 800px)': {
                            padding: '5px 20px',
                            gridTemplateColumns: '1fr',
                            gridGap: 10
                        }
                    }}>
                        <FormControl>
                            <div style={{ color: '#082C91' }} >โรงพยาบาลที่ขอรับคำปรึกษา</div>
                            <Select size="small"
                                value={hospital || ' '}
                                onChange={(event) => {
                                    const {
                                        target: { value },
                                    } = event;
                                    setHospital(value)
                                    setDepartment('')
                                    setOptionDepartment([])
                                    setRoom('')
                                    setOptionRoom([])
                                    console.log(value)
                                }}
                            >
                                <MenuItem value=" ">เลือกโรงพยาบาล</MenuItem>
                                {optionHospital.map((item, index) => (
                                    <MenuItem
                                        key={index}
                                        value={item['ClinicCode']}
                                    >
                                        {item['ClinicName']}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl>
                            <div style={{ color: '#082C91' }} >แผนกที่เข้ารับบริการ</div>
                            <Select size="small"
                                disabled={hospital === '' ? true : null}
                                value={department || ' '}
                                onChange={(event) => {
                                    const {
                                        target: { value },
                                    } = event;
                                    setDepartment(value)
                                    setRoom('')
                                    setOptionRoom([])
                                    console.log(value)
                                }}
                            >
                                <MenuItem value=" ">เลือกแผนก</MenuItem>
                                {optionDepartment.map((item, index) => (
                                    <MenuItem
                                        key={index}
                                        value={item['DepartmentCode']}
                                    >
                                        {item['DepartmentName']}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl>
                            <div style={{ color: '#082C91' }} >เลือกห้อง</div>
                            <Select size="small"
                                disabled={department === '' ? true : null}
                                value={room || ' '}
                                onChange={(event) => {
                                    const {
                                        target: { value },
                                    } = event;
                                    setRoom(value)
                                }}
                            >
                                <MenuItem value=" ">ห้อง</MenuItem>
                                {optionRoom?.map((item, index) => (
                                    <MenuItem
                                        key={index}
                                        value={item['RoomConferenceName']}
                                    >
                                        {item['RoomConferenceName']}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <Box sx={{
                            '@media (max-width: 800px)': {
                                display: 'flex',
                                justifyContent: 'center'
                            }
                        }}>
                            <Button
                                variant="contained"
                                disabled={room === '' ? true : null}
                                onClick={() => { clickConference() }}
                            >Conference</Button>
                        </Box>

                    </Box>
                </Box>

                <Box sx={{
                    backgroundColor: '#FFFFFF',
                    border: '1px solid #E1E3E9',
                    borderRadius: 2,
                    marginTop: 2,
                    padding: 2,
                    '@media (max-width: 1023px)': {
                        marginTop: 2,
                        padding: 1
                    },
                    '@media (max-width: 800px)': {
                        marginTop: 1,
                        padding: 1
                    }
                }}>
                    <Box sx={{
                        display: 'grid',
                        gridTemplateColumns: '2fr 2fr 2fr 1fr',
                        gridGap: 30,
                        alignItems: 'end',
                        '@media (max-width: 1023px)': {
                            gridTemplateColumns: '1fr 1fr',
                            gridGap: 20,
                        },
                        '@media (max-width: 800px)': {
                            gridTemplateColumns: '1fr',
                            gridGap: 10,
                        }
                    }}>
                        <FormControl>
                            <div style={{ color: '#082C91' }} >ค้นหาโดยวันที่</div>
                            <TextField
                                size='small'
                                value={convertDate(date['$d'])}
                                InputProps={{
                                    readOnly: true,
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton onClick={() => {
                                                setOpenCalendar(true)
                                            }}>
                                                <CalendarTodayIcon />
                                            </IconButton>
                                        </InputAdornment>
                                    )
                                }} />
                        </FormControl>

                        <FormControl>
                            <div style={{ color: '#082C91' }} >ค้นหาโดยชื่อ-นามสกุล</div>
                            <TextField
                                size='small'
                                placeholder={'กรุณาระบุชื่อ-นามสกุลของผู้ป่วย'}
                                value={namePatient}
                                onChange={(event) => {
                                    const {
                                        target: { value },
                                    } = event;
                                    setNamePatient(value)
                                }}
                            ></TextField>
                        </FormControl>

                        <FormControl>
                            <div style={{ color: '#082C91' }} >ค้นหาโดยเลขประจำตัวประชาชน</div>
                            <TextField
                                size='small'
                                placeholder={'กรุณาระบุเลขประจำตัวประชาชนของผู้ป่วย'}
                                value={pid}
                                onChange={(event) => {
                                    const {
                                        target: { value },
                                    } = event;
                                    const maxLength = 13;
                                    const numericRegex = /^[0-9]*$/;
                                    if (value.length <= maxLength && numericRegex.test(value)) {
                                        setPid(value)
                                    }
                                }}
                            ></TextField>
                        </FormControl>

                        <div style={{ color: '#747676' }}>จำนวนทั้งหมด {dataSystem.length}</div>
                    </Box>

                    <TableContainer>
                        <Table sx={{ marginTop: 3, minWidth: '1500px' }}>
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{ color: '#082C91', textAlign: 'center' }}>#</TableCell>
                                    <TableCell sx={{ color: '#082C91' }}>โรงพยาบาลขอรับคำปรึกษา</TableCell>
                                    <TableCell sx={{ color: '#082C91', textAlign: 'center' }}>แผนก</TableCell>
                                    <TableCell sx={{ color: '#082C91' }}>รายชื่อ</TableCell>
                                    <TableCell sx={{ color: '#082C91', textAlign: 'center' }}>วันและเวลานัดหมาย</TableCell>
                                    <TableCell sx={{ color: '#082C91', textAlign: 'center' }}>ประวัติการแพทย์</TableCell>
                                    <TableCell sx={{ color: '#082C91', textAlign: 'center' }}>บันทึกการรักษา</TableCell>
                                    <TableCell sx={{ color: '#082C91', textAlign: 'center' }}>ลบนัดหมาย</TableCell>
                                </TableRow>
                            </TableHead>
                            {showList.length === 0 ?
                                <TableBody>
                                    <TableRow>
                                        <TableCell
                                            colSpan={8}
                                            align='center'
                                            sx={{ fontSize: 18 }}
                                        >ไม่พบข้อมูล</TableCell>
                                    </TableRow>
                                </TableBody>
                                : null
                            }

                            {showList.map((i, idx) => (
                                <TableBody key={idx}>
                                    <TableRow>
                                        <TableCell sx={{ color: '#747676', textAlign: 'center' }}>{1 + idx}</TableCell>
                                        <TableCell sx={{ color: '#747676' }}>{i['HospitalNameTo']}</TableCell>
                                        <TableCell sx={{ color: '#747676', textAlign: 'center' }}>{i['DepartmentName'] === null ? '-' : i['DepartmentName']}</TableCell>
                                        <TableCell sx={{ color: '#747676' }}>{i['Name']}</TableCell>
                                        <TableCell sx={{ color: '#747676', textAlign: 'center' }}>{convertDate(i['AppointDate']) + ' ' + i['AppointTime'] + 'น.'}</TableCell>
                                        <TableCell sx={{ color: '#747676', textAlign: 'center' }}>
                                            <Button
                                                sx={history}
                                                onClick={() => { systempatientAndpointofcare(i['PID']) }}
                                            >ดูประวัติการแพทย์
                                            </Button>
                                        </TableCell>
                                        <TableCell sx={{ color: '#747676' }}>
                                            <Box sx={{ display: 'flex', justifyContent: 'center', gridGap: '1rem' }}>
                                                <Button
                                                    sx={i['Order'].length > 0 ? buttom_secondary : buttom_primary}
                                                    onClick={() => { openModalRecondKeeping(i['DocNumber'], i) }}
                                                    style={{ fontSize: i['Order'].length > 0 ? 'calc(13px + 0.05vw)' : '' }}
                                                >{i['Order'].length > 0 ? "เปิดบันทึกการรักษา" : "บันทึกการรักษา"}</Button>
                                                <Button
                                                    sx={buttom_primary}
                                                    onClick={() => { openTreatmentHistory(i['PID'], i['DocNumber']) }}
                                                >ประวัติการรักษา</Button>
                                            </Box>
                                        </TableCell>
                                        <TableCell sx={{ color: '#082C91', textAlign: 'center' }}>
                                            <DeleteRoundedIcon style={{ cursor: 'pointer' }} onClick={() => { deleteAppointment(i['DocNumber']) }} />
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            ))}


                        </Table>
                    </TableContainer>
                </Box >

                <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    margin: 2
                }}>
                    <Box sx={{ width: '100px' }}>
                        <FormControl fullWidth>
                            <Select
                                value={numPage}
                                onChange={(e) => {
                                    const {
                                        target: { value },
                                    } = e;
                                    setNumPage(value)
                                }}
                                size='small'
                                sx={{ width: '100px', fontSize: '14px' }}
                            >
                                <MenuItem value={5}>5</MenuItem>
                                <MenuItem value={10}>10</MenuItem>
                                <MenuItem value={20}>20</MenuItem>
                            </Select>
                        </FormControl>
                    </Box>
                    <Stack spacing={2}>
                        <Pagination
                            count={maxPage}
                            page={page}
                            onChange={handlePageChange}
                            shape="rounded"
                            color="primary"
                        />
                    </Stack>
                </Box>

                {openModal ?
                    <>
                        <ModalRecordKeeping
                            onClose={() => { setOpenModal(false) }}
                            DocNumber={docNumber}
                            item={itemFindIndex}
                            getdata={() => findTelemedicine()}
                        />
                    </>
                    : null
                }
            </Box >
        </>

    )
}

const HospitalPatients = () => {
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)

    const [hospital, setHospital] = useState('')
    const [optionHospital, setOptionHospital] = useState([])
    const [department, setDepartment] = useState('')
    const [optionDepartment, setOptionDepartment] = useState([])
    const [date, setDate] = useState(dayjs(moment(new Date()).format('YYYY-MM-DD')))
    const [pid, setPid] = useState('')

    const [dataSystem, setDataSystem] = useState([])
    const [dataAll, setDataAll] = useState([])
    const [dataHos, setDataHos] = useState([])

    const [room, setRoom] = useState('')
    const [optionRoom, setOptionRoom] = useState([])
    const [openCalendar, setOpenCalendar] = useState(false)
    const [openModal, setOpenModal] = useState(false)
    const [docNumber, setDocNumber] = useState('')
    const [itemFindIndex, setItemFindIndex] = useState(null)
    const [disabledDay, setDisabledDay] = useState([])
    const [showList, setShowList] = useState([])
    const [namePatient, setNamePatient] = useState('')
    const [numPage, setNumPage] = useState(5)
    const [page, setPage] = useState(1)
    const [maxPage, setMaxPage] = useState(1)


    useEffect(() => {
        getHospital()
        findTelemedicineHospital()
    }, [])

    useEffect(() => {
        setShowList([])
        findDepartment()
    }, [hospital])

    useEffect(() => {
        findRoom()
    }, [department])


    useEffect(() => {
        findTelemedicineHospital()
    }, [numPage, hospital, department])

    useEffect(() => {
        findRoom()
    }, [department])

    useEffect(() => {
        let start = page * numPage - numPage
        setShowList(searchData().slice(start, start + numPage))
    }, [page, dataSystem, namePatient, pid])

    const findTelemedicineHospital = async () => {

        let dateNow = moment(date['$d']).format('YYYY-MM-DD')
        setLoading(true)
        let res = await api.findTelemedicineHospital(dateNow)
        setLoading(false)
        if (res) {
            if (res['data']['code'] === 200) {
                // console.log(res['data']['data'])
                setDataSystem(res['data']['data'])

                // conditon search ......
                if (hospital === ' ') {
                    // console.log('----> 1')
                    setDataSystem(res['data']['data'])
                    setMaxPage((Math.ceil(res['data']['data'].length / numPage)))
                } else if (hospital !== '' && (department === '' || department === ' ')) {
                    // console.log('----> 2')
                    console.log(res['data']['data'])
                    console.log(hospital)
                    
                    const List = []
                    for (let i = 0; i < res['data']['data'].length; i++) {
                        if (res['data']['data'][i]['HospitalCodeFrom'] === hospital) {
                            List.push(res['data']['data'][i])
                        }
                    }
                    console.log(List)
                    setDataSystem(List)
                    setMaxPage((Math.ceil(List.length / numPage)))
                } else if (hospital !== '' && department !== '') {
                    // console.log('----> 3')
                    const List = []
                    for (let i = 0; i < res['data']['data'].length; i++) {
                        if (res['data']['data'][i]['DepartmentCode'] === department && res['data']['data'][i]['HospitalCodeFrom'] === hospital) {
                            List.push(res['data']['data'][i])
                        }
                    }
                    setDataSystem(List)
                    setMaxPage((Math.ceil(List.length / numPage)))
                } else {
                    console.log('----> 4')
                    setDataSystem(res['data']['data'])
                    setMaxPage((Math.ceil(res['data']['data'].length / numPage)))
                }

            } else {
                console.log(res['data']['message'], ' ผู้ป่วยจากโรงพยาบาล')
                setDataSystem([])
            }
        } else {
            notifyError('ไม่ตอบสนอง')
        }
    }

    const getHospital = async () => {
        setLoading(true)
        let res = await api.findDepartment()
        setLoading(false)
        if (res) {
            if (res['data']['code'] === 200) {
                // console.log(res)
                setDataAll(res['data']['data'])
                // console.log(res['data']['data'])

                let hospitalFrom = []
                // findHospital TELEQUEUE
                res['data']['data'].map((item) => {
                    if (item['DepartmentType'] === 'TELEQUEUE') {
                        hospitalFrom.push(item)
                    }
                })
                // console.log(hospitalFrom)

                // find Clinic All
                let ClinicAll = hospitalFrom.filter((hospital) =>
                    hospital.Clinic.some(clinic => clinic.ClinicCode === localStorage.getItem('hospital_code'))
                );

                // getData Hospital
                let HospitalAll = ClinicAll.map(hospital => hospital)

                // remove data repeat
                let new_h = HospitalAll.filter((item, index) => {
                    return index === HospitalAll.findIndex(o => o.HospitalName === item.HospitalName)
                })
                // console.log(new_h) 
                setOptionHospital(new_h)
                setDataHos(HospitalAll)

            } else {
                notifyInfo(res['data']['message'])
            }
        } else {
            notifyError('ไม่ตอบสนอง')
        }
    }

    const findDepartment = async () => {
        setOptionDepartment(dataHos)
    }

    const findRoom = () => {
        // console.log(optionDepartment)
        // console.log(department)

        // find department select
        let resultRoom = optionDepartment.filter((item) => item.DepartmentCode === department)

        // remove data repeat
        let conference = resultRoom.map((item) =>
            item.RoomConference.filter((obj, index, array) =>
                index === array.findIndex(o => o.RoomConferenceName === obj.RoomConferenceName)
            )
        )
        // console.log(conference);
        setOptionRoom(conference)
    }

    const clickConference = () => {
        // console.log(optionRoom[0])
        // console.log(room)
        let linkCon = optionRoom[0].filter((item, index, array) => index === array.findIndex(o => o.RoomConferenceName === room))
        // console.log(linkCon[0].ConferenceURL)
        let url = linkCon[0].ConferenceURL
        window.open(url, '_system')
    }

    const convertDate = (dataDate) => {
        const date = new Date(dataDate)
        const optionDate = {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        }
        const thaiLocale = 'th-TH';
        const formattedDate = date.toLocaleDateString(thaiLocale, optionDate)

        const newDate = `${formattedDate}`
        return newDate
    }

    const systempatientAndpointofcare = async (pid) => {
        window.open(`/systemPatientInformation?PID=${pid}`)
    }

    const openModalRecondKeeping = (DocNumber, ItemFindIndex) => {
        setDocNumber(DocNumber)
        setOpenModal(true)
        setItemFindIndex(ItemFindIndex)
    }

    const openTreatmentHistory = (pid, DocNumber) => {
        navigate('/treatmentHistory', {
            state: {
                PID: pid,
                DocNumber: DocNumber
            }
        })
    }

    const deleteAppointment = (DocNumber) => {
        cancelTelemedicine(DocNumber)
    }

    const cancelTelemedicine = async (DocNumber) => {
        setLoading(true)
        let res = await api.cancelTelemedicine(DocNumber)
        setLoading(false)
        if (res) {
            if (res['data']['code'] === 200) {
                notifySuccess('ลบนัดหมายสำเร็จ')
                findTelemedicineHospital()
            } else {
                notifyInfo(res['data']['message'])
            }
        } else {
            notifyError('ไม่ตอบสนอง')
        }
    }

    const searchData = () => {
        return dataSystem.filter((item) =>
            (namePatient === '' || item['Name'].includes(namePatient)) &&
            (pid === '' || item['PID'].includes(pid))
        )
    }

    const handlePageChange = (event, page) => {
        setPage(page)
    }

    if (openModal) {
        document.body.style.overflow = "hidden";
    } else {
        document.body.style.overflow = "auto";
    }

    return (
        <>
            <LoaderAnimation loading={loading} />
            {openCalendar &&
                <ModalCalendar
                    onClose={() => { setOpenCalendar(false) }}
                    onFinished={() => {
                        findTelemedicineHospital()
                    }}
                    value={date ? dayjs(moment(date['$d']).format('YYYY-MM-DD')) : dayjs(moment(new Date()).format('YYYY-MM-DD'))}
                    onChange={(e) => setDate(e)}
                    disableDay={disabledDay}
                />
            }
            <Box sx={{
                fontSize: 18,
                '@media (max-width: 1023px)': {
                    fontSize: 14,
                },
                '@media (max-width: 800px)': {
                    fontSize: 12,
                }
            }}>
                <Box sx={{
                    backgroundColor: '#FFFFFF',
                    border: '1px solid #E1E3E9',
                    borderRadius: 2,
                    marginTop: 2,
                    padding: 2,
                    '@media (max-width: 1023px)': {
                        marginTop: 2,
                        padding: 1
                    },
                    '@media (max-width: 800px)': {
                        marginTop: 1,
                        padding: 1
                    }
                }}>
                    <div style={{ color: '#082C91' }} >Filters</div>
                    <Box sx={{
                        padding: '10px 40px',
                        display: 'grid',
                        gridTemplateColumns: '2fr 2fr 2fr 1fr',
                        gridGap: 30,
                        alignItems: 'flex-end',
                        '@media (max-width: 1100px)': {
                            padding: '5px 30px',
                            gridTemplateColumns: '1fr 1fr',
                            gridGap: 20
                        },
                        '@media (max-width: 800px)': {
                            padding: '5px 20px',
                            gridTemplateColumns: '1fr',
                            gridGap: 10
                        }
                    }}>
                        <FormControl>
                            <div style={{ color: '#082C91' }} >โรงพยาบาลขอรับคำปรึกษา</div>
                            <Select size="small"
                                value={hospital || ' '}
                                onChange={(event) => {
                                    const {
                                        target: { value },
                                    } = event;
                                    setHospital(value)
                                }}
                            >
                                <MenuItem value=" ">เลือกโรงพยาบาล</MenuItem>
                                {optionHospital.map((item, index) => (
                                    <MenuItem
                                        key={index}
                                        value={item['HospitalCode']}
                                    >
                                        {item['HospitalName']}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl>
                            <div style={{ color: '#082C91' }} >แผนกที่เข้ารับบริการ</div>
                            <Select size="small"
                                disabled={hospital === '' ? true : null}
                                value={department || ' '}
                                onChange={(event) => {
                                    const {
                                        target: { value },
                                    } = event;
                                    setDepartment(value)
                                }}
                            >
                                <MenuItem value=" ">เลือกแผนก</MenuItem>
                                {optionDepartment.map((item, index) => (
                                    <MenuItem
                                        key={index}
                                        value={item['DepartmentCode']}
                                    >
                                        {item['DepartmentName']}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl>
                            <div style={{ color: '#082C91' }} >เลือกห้อง</div>
                            <Select size="small"
                                disabled={department === '' ? true : null}
                                value={room || ' '}
                                onChange={(event) => {
                                    const {
                                        target: { value },
                                    } = event;
                                    setRoom(value)
                                    // console.log(value)
                                }}
                            >
                                <MenuItem value=" ">ห้อง</MenuItem>
                                {optionRoom[0]?.map((item, index) => (
                                    <MenuItem
                                        key={index}
                                        value={item['RoomConferenceName']}
                                    >
                                        {item['RoomConferenceName']}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <Box sx={{
                            '@media (max-width: 800px)': {
                                display: 'flex',
                                justifyContent: 'center'
                            }
                        }}>
                            <Button
                                variant="contained"
                                disabled={room === '' ? true : null}
                                onClick={() => { clickConference() }}
                            >Conference</Button>
                        </Box>

                    </Box>
                </Box>

                <Box
                    sx={{
                        backgroundColor: '#FFFFFF',
                        border: '1px solid #E1E3E9',
                        borderRadius: 2,
                        marginTop: 2,
                        padding: 2,
                        '@media (max-width: 1023px)': {
                            marginTop: 2,
                            padding: 1
                        },
                        '@media (max-width: 800px)': {
                            marginTop: 1,
                            padding: 1
                        }
                    }}
                >
                    <Box sx={{
                        display: 'grid',
                        gridTemplateColumns: '2fr 2fr 2fr 1fr',
                        gridGap: 30,
                        alignItems: 'end',
                        '@media (max-width: 1023px)': {
                            gridTemplateColumns: '1fr 1fr',
                            gridGap: 20,
                        },
                        '@media (max-width: 800px)': {
                            gridTemplateColumns: '1fr',
                            gridGap: 10,
                        }
                    }}>
                        <FormControl>
                            <div style={{ color: '#082C91' }} >ค้นหาโดยวันที่</div>
                            <TextField
                                size='small'
                                value={convertDate(date['$d'])}
                                InputProps={{
                                    readOnly: true,
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton onClick={() => {
                                                setOpenCalendar(true)
                                            }}>
                                                <CalendarTodayIcon />
                                            </IconButton>
                                        </InputAdornment>
                                    )
                                }} />
                        </FormControl>

                        <FormControl>
                            <div style={{ color: '#082C91' }} >ค้นหาโดยชื่อ-นามสกุล</div>
                            <TextField
                                size='small'
                                placeholder={'กรุณาระบุชื่อ-นามสกุลของผู้ป่วย'}
                                value={namePatient}
                                onChange={(event) => {
                                    const {
                                        target: { value },
                                    } = event;
                                    setNamePatient(value)
                                }}
                            ></TextField>
                        </FormControl>

                        <FormControl>
                            <div style={{ color: '#082C91' }} >ค้นหาโดยเลขประจำตัวประชาชน</div>
                            <TextField
                                size='small'
                                placeholder={'กรุณาระบุเลขประจำตัวประชาชนของผู้ป่วย'}
                                value={pid}
                                onChange={(event) => {
                                    const {
                                        target: { value },
                                    } = event;
                                    const maxLength = 13;
                                    const numericRegex = /^[0-9]*$/;
                                    if (value.length <= maxLength && numericRegex.test(value)) {
                                        setPid(value)
                                    }
                                }}
                            ></TextField>
                        </FormControl>

                        <div style={{ color: '#747676' }}>จำนวนทั้งหมด {dataSystem.length}</div>
                    </Box>

                    <TableContainer>
                        <Table sx={{ marginTop: 3, minWidth: '1500px' }}>
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{ color: '#082C91', textAlign: 'center' }}>#</TableCell>
                                    <TableCell sx={{ color: '#082C91' }}>โรงพยาบาลขอคำปรึกษา</TableCell>
                                    <TableCell sx={{ color: '#082C91', textAlign: 'center' }}>แผนก</TableCell>
                                    <TableCell sx={{ color: '#082C91' }}>รายชื่อ</TableCell>
                                    <TableCell sx={{ color: '#082C91', textAlign: 'center' }}>วันและเวลานัดหมาย</TableCell>
                                    <TableCell sx={{ color: '#082C91', textAlign: 'center' }}>ประวัติการแพทย์</TableCell>
                                    <TableCell sx={{ color: '#082C91', textAlign: 'center' }}>บันทึกการรักษา</TableCell>
                                    <TableCell sx={{ color: '#082C91', textAlign: 'center' }}>ลบนัดหมาย</TableCell>
                                </TableRow>
                            </TableHead>

                            {showList.length === 0 ?
                                <TableBody>
                                    <TableRow>
                                        <TableCell
                                            colSpan={8}
                                            align='center'
                                            sx={{ fontSize: 18 }}
                                        >ไม่พบข้อมูล</TableCell>
                                    </TableRow>
                                </TableBody>
                                : null
                            }

                            {showList?.map((i, idx) => (
                                <TableBody key={idx}>
                                    <TableRow>
                                        <TableCell sx={{ color: '#747676', textAlign: 'center' }}>{1 + idx}</TableCell>
                                        <TableCell sx={{ color: '#747676' }}>{i['HospitalNameFrom']}</TableCell>
                                        <TableCell sx={{ color: '#747676', textAlign: 'center' }}>{i['DepartmentName'] === null ? '-' : i['DepartmentName']}</TableCell>
                                        <TableCell sx={{ color: '#747676' }}>{i['Name']}</TableCell>
                                        <TableCell sx={{ color: '#747676', textAlign: 'center' }}>
                                            {
                                                convertDate(i['AppointDate']) + ' ' + i['AppointTime'] + 'น.'
                                            }
                                        </TableCell>
                                        <TableCell sx={{ color: '#747676', textAlign: 'center' }}>
                                            <Button
                                                sx={history}
                                                onClick={() => { systempatientAndpointofcare(i['PID']) }}
                                            >ดูประวัติการแพทย์
                                            </Button>
                                        </TableCell>
                                        <TableCell sx={{ color: '#747676' }}>
                                            <Box sx={{ display: 'flex', justifyContent: 'center', gridGap: '1rem' }}>
                                                <Button
                                                    sx={i['Order']?.length > 0 ? buttom_secondary : buttom_primary}
                                                    onClick={() => { openModalRecondKeeping(i['DocNumber'], i) }}
                                                    style={{ fontSize: i['Order']?.length > 0 ? 'calc(13px + 0.05vw)' : '' }}
                                                >{i['Order']?.length > 0 ? "เปิดบันทึกการรักษา" : "บันทึกการรักษา"}</Button>
                                                <Button
                                                    sx={buttom_primary}
                                                    onClick={() => { openTreatmentHistory(i['PID'], i['DocNumber']) }}
                                                >ประวัติการรักษา</Button>
                                            </Box>
                                        </TableCell>
                                        <TableCell sx={{ color: '#082C91', textAlign: 'center' }}>
                                            <DeleteRoundedIcon style={{ cursor: 'pointer' }} onClick={() => { deleteAppointment(i['DocNumber']) }} />
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            ))}
                        </Table>
                    </TableContainer>
                </Box>

                <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    margin: 2
                }}>
                    <Box sx={{ width: '100px' }}>
                        <FormControl fullWidth>
                            <Select
                                value={numPage}
                                onChange={(e) => {
                                    const {
                                        target: { value },
                                    } = e;
                                    setNumPage(value)
                                }}
                                size='small'
                                sx={{ width: '100px', fontSize: '14px' }}
                            >
                                <MenuItem value={5}>5</MenuItem>
                                <MenuItem value={10}>10</MenuItem>
                                <MenuItem value={20}>20</MenuItem>
                            </Select>
                        </FormControl>
                    </Box>
                    <Stack spacing={2}>
                        <Pagination
                            count={maxPage}
                            page={page}
                            onChange={handlePageChange}
                            shape="rounded"
                            color="primary"
                        />
                    </Stack>
                </Box>

                {openModal ?
                    <>
                        <ModalRecordKeeping
                            onClose={() => { setOpenModal(false) }}
                            DocNumber={docNumber}
                            item={itemFindIndex}
                            getdata={() => findTelemedicineHospital()}
                        />
                    </>
                    : null
                }
            </Box >
        </>
    )
}
